import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ShortcutsService {
  @Output() search: EventEmitter<any> = new EventEmitter<any>();
  pressedKeys: Array<number> = [];

  constructor() {
    document.addEventListener('keydown', (e) => {
      this.keydown(e);
    });
    document.addEventListener('keyup', (e) => {
      this.keyup(e);
    });
  }

  public keydown(event): void {
    if (
      event.target.nodeName.toLowerCase() === 'input' ||
      event.target.nodeName.toLowerCase() === 'textarea' ||
      event.target.className.toLowerCase().includes('ql-editor')
    )
      return;
    if (!event.repeat) {
      const index: number = this.pressedKeys.indexOf(event.which);
      if (index === -1) this.pressedKeys.push(event.which);
      if (this.checkShortcut()) event.preventDefault();
    }
  }

  public keyup(event): void {
    const index: number = this.pressedKeys.indexOf(event.which);
    if (index > -1) this.pressedKeys.splice(index, 1);
  }

  private checkShortcut(): boolean {
    for (let i = 0; i < SHORTCUTS.length; i++) {
      if (this.checkKeys(SHORTCUTS[i].keys)) {
        this.runShortcut(SHORTCUTS[i].name);
        return true;
      }
    }
    return false;
  }

  private runShortcut(name: string): void {
    switch (name) {
      case 'SEARCH':
        this.search.emit();
        break;
      default:
        break;
    }
  }

  private checkKeys(shortcut: Array<number>): boolean {
    return JSON.stringify(this.pressedKeys) === JSON.stringify(shortcut);
  }
}

export const SHORTCUTS: Array<{
  name: string;
  keys: Array<number>;
}> = [
  {
    name: 'SEARCH',
    keys: [17, 70],
  },
];
